import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LookupsStore } from './store/lookups.store';
import { Observable } from 'rxjs';

export const appResolver: ResolveFn<boolean | Observable<any>> = (route, state) => {
  const lookupsStore = inject(LookupsStore);
  return lookupsStore.getAllBlocksResolve();
};
